import TemplatePrivacyPolicy from './TemplatePrivacyPolicy'

export default TemplatePrivacyPolicy
